import { ready } from '~/core'
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, A11y, FreeMode, Scrollbar, Controller } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'

// Swiper.use([Navigation, Pagination, Autoplay])

ready('swiperMain', '.swiperMain', (swiperDefault) => {
  const uniqueClass = Date.now().toString(36) + Math.random().toString(36).substring(2)
  // add unique class to next button
  const nextEl = swiperDefault.querySelector('.swiper-button-next')
  nextEl.classList.add(`swiper-button-next--${uniqueClass}`)
  // add unique class to prev button
  const prevEl = swiperDefault.querySelector('.swiper-button-prev')
  prevEl.classList.add(`swiper-button-prev--${uniqueClass}`)

  const swiperMain = new Swiper(swiperDefault, {
    modules: [Navigation, Pagination],
    loop: false,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: `.swiper-button-next--${uniqueClass}`,
      prevEl: `.swiper-button-prev--${uniqueClass}`,
    },
    breakpoints: {
      768: {
        spaceBetween: 30,
        slidesPerView: 2,
      },
      1024: {
        spaceBetween: 40,
        slidesPerView: 3,
      },
    },
  })
})

ready('swiperTestimonials', '.swiper--testimonials,.swiper--account-slider', (testimonials) => {
  const isAccountSlider = testimonials.classList.contains('swiper--account-slider')

  const slides = [...testimonials.querySelectorAll('.swiper-slide')]
  const uniqueClass = Date.now().toString(36) + Math.random().toString(36).substring(2)
  const navigationContainer = testimonials.querySelector('.swiper-navigation')

  // add unique class to next button
  const nextArrow = testimonials.querySelector('.swiper-button-next')
  nextArrow.classList.add(`swiper-button-next--${uniqueClass}`)

  const prevArrow = testimonials.querySelector('.swiper-button-prev')
  prevArrow.classList.add(`swiper-button-prev--${uniqueClass}`)

  const isSecondary = testimonials.classList.contains('swiper--secondary')

  slides.length === 1 && !isSecondary ? testimonials.classList.add('swiper--single') : null
  slides.length === 1 ? testimonials.parentElement.classList.add('centered') : null

  const swiperMain = new Swiper(testimonials, {
      modules: [Navigation, Pagination, Autoplay],
    spaceBetween: isSecondary ? 0 : slides.length === 1 ? 0 : 20,
    slidesPerView: isSecondary ? 1 : slides.length === 1 ? 1 : 1,
    watchOverflow: false,
    centeredSlides: isSecondary ? true : slides.length === 1 ? true : false,
    slidesPerGroup: 1,
    slidesPerGroupAuto: true,
      autoplay: {
          delay:5000,
          disableOnInteraction: true,
      },
    loop: false,
    threshold: 50,
    thresholdDelta: 50,
    thresholdTime: 750,
    navigation: {
      nextEl: `.swiper-button-next--${uniqueClass}`,
      prevEl: `.swiper-button-prev--${uniqueClass}`,
    },
    breakpoints: {
      992: {
        slidesPerView: isSecondary
          ? 1
          : slides.length === 1
          ? 1
          : slides.length > 1 && slides.length < 3
          ? 2
          : slides.length > 2 && slides.length <= 5
          ? 3
          : 2.75,
      },
      1024: {
        slidesPerView: isSecondary
          ? 1
          : slides.length === 1
          ? 1
          : slides.length > 1 && slides.length < 3
          ? 2
          : slides.length > 2 && slides.length <= 5
          ? 3
          : 2.75,
      },
    },
  })

    if (!isSecondary) {
        swiperMain.autoplay.stop()
    }
    if (isAccountSlider) {
        swiperMain.autoplay.stop()
    }

  function initView() {
    const areButtonsDisabled =
      prevArrow.classList.contains('swiper-button-disabled') && nextArrow.classList.contains('swiper-button-disabled')

    if (areButtonsDisabled) {
      navigationContainer.style.display = 'none'
      navigationContainer.style.opacity = 0
    } else {
      navigationContainer.style.display = 'flex'
      navigationContainer.style.opacity = 1
    }
  }

  window.addEventListener('resize', () => initView())

  window.addEventListener('beforeunload', () => {
    window.removeEventListener('resize', () => initView())
  })

  initView()
})

ready('swiperMb', '.swiper--mb', (swiperMb) => {
  const uniqueClass = Date.now().toString(36) + Math.random().toString(36).substring(2)
  // add unique class to next button
  const nextEl = swiperMb.querySelector('.swiper-button-next')
  nextEl.classList.add(`swiper-button-next--${uniqueClass}`)
  const prevEl = swiperMb.querySelector('.swiper-button-prev')
  prevEl.classList.add(`swiper-button-prev--${uniqueClass}`)

  const thumb = swiperMb.querySelector('.mediaBlock-media img');
  let lastHeight = thumb.clientHeight;

  setInterval(() => {
    if (thumb.clientHeight !== lastHeight) {
      lastHeight = thumb.clientHeight;
      nextEl.style.top = `${thumb.clientHeight / 2}px`;
      prevEl.style.top = `${thumb.clientHeight / 2}px`;
    }
  }, 500)

  const swiperMain = new Swiper(swiperMb, {
    modules: [Navigation, Pagination],
    spaceBetween: 18,
    slidesPerView: 1,
    slidesPerGroup: 1,
    threshold: 50,
    thresholdDelta: 50,
    thresholdTime: 750,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: `.swiper-button-next--${uniqueClass}`,
      prevEl: `.swiper-button-prev--${uniqueClass}`,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
  })
})

ready('swiperMbSmall', '.swiper--mb-sm', (swiperMbSm) => {
  const uniqueClass = Date.now().toString(36) + Math.random().toString(36).substring(2)
  // add unique class to next button
  const nextEl = swiperMbSm.querySelector('.swiper-button-next')
  nextEl.classList.add(`swiper-button-next--${uniqueClass}`)
  const prevEl = swiperMbSm.querySelector('.swiper-button-prev')
  prevEl.classList.add(`swiper-button-prev--${uniqueClass}`)

  const swiperMain = new Swiper(swiperMbSm, {
    modules: [Navigation, Pagination],
    spaceBetween: 10,
    slidesPerView: 2.125,
    threshold: 50,
    thresholdDelta: 50,
    thresholdTime: 750,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: `.swiper-button-next--${uniqueClass}`,
      prevEl: `.swiper-button-prev--${uniqueClass}`,
    },
    breakpoints: {
      768: {
        spaceBetween: 16,
        slidesPerView: 3.5,
      },
      1024: {
        spaceBetween: 16,
        slidesPerView: 5.5,
      },
    },
  })
})

ready('swiper-hero-icons', '.heroUnified-menuSwiper', (swiperHero) => {
  const swiperUnified = new Swiper(swiperHero, {
    modules: [Pagination, FreeMode, A11y],
    spaceBetween: 8,
    slidesPerView: "auto",
    slidesPerGroup: 2,
    pagination: {
      el: '.heroUnified-menu-pagination',
      clickable: true,
    },
    freeMode: {
      enabled: true,
      sticky: false,
    },
    a11y: {
      enabled: true,
    },
    breakpoints: {
      480: {
        slidesPerGroup: 3,
        spaceBetween: 8,
      },
      630: {
        slidesPerGroup: 4,
        spaceBetween: 8,
      },
      768: {
        slidesPerGroup: 4,
        spaceBetween: 16,
      },
      780: {
        slidesPerGroup: 5,
        spaceBetween: 16,
      },
      992: {
        slidesPerGroup: 7,
        spaceBetween: 24,
      },
    }
  })
})



ready('product comparison table', '.prod-comp-table', (pcTable) => {
  const swiperTableEl = pcTable.closest('.swiper')

  const prodCompHeader = document.querySelector('.prod-comp-header')
  const swiperHeaderEl = prodCompHeader.closest('.swiper')
  const prodCompHeaderSwiper = new Swiper(swiperHeaderEl, {
    modules: [FreeMode, Controller],
    slidesPerView: "auto",
    direction: 'horizontal',
    freeMode: true,
    grabCursor: true
  })
  const prodCompTableSwiper = new Swiper(swiperTableEl, {
    modules: [FreeMode, Controller],
    slidesPerView: "auto",
    direction: 'horizontal',
    freeMode: true,
    grabCursor: true
  })

  prodCompHeaderSwiper.controller.control = prodCompTableSwiper;
  prodCompTableSwiper.controller.control = prodCompHeaderSwiper;
  prodCompHeaderSwiper.controller.by = 'container';
  prodCompTableSwiper.controller.by = 'container';
})